import { HttpParams } from '@angular/common/http';
import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { CommonService } from 'src/app/services/common.service';
import { DataService, EmmiterService } from 'src/app/services/data.service';
import { MagnifyFieldSearchComponent } from 'src/app/shared/components/magnify-field-search/magnify-field-search.component';
import { Router } from '@angular/router';
import { EncryptDecryptService } from 'src/app/services/encrypt-decrypt.service';
import {MemoryStorageService} from 'src/app/services/memory-storage.service';

@Component({
  selector: 'app-dashboard-lite',
  templateUrl: './dashboard-lite.component.html',
  styleUrls: ['./dashboard-lite.component.css']
})
export class DashboardLiteComponent implements OnInit {

  isDisplaySearchBox = false;
  searchURN: string = "";
  isDisplayTransactionData = false;
  lstTransaction: any[] = [];
  lstHeaders = [];
  activeWorkList: string = 'All Work Items';
  statistics: any = [];
  isBright: boolean = false;
  recordsPerPage: number = 50;
  currentPage: number = 1;
  lstRecordsPerPage = [10, 50, 100];
  totalPages = 1;
  firstRecord = 1;
  lastRecord = 1;
  lstTotalPage: any = [];
  lstWorkList: any = [];
  selectedWorklistId: number = 0;
  modalReference: any;
  docTypeList: any = [];
  selectedDocumentType: any = { docTypeId: 0, docTypeName: '' };
  advanceSearchFields: any = [];
  frmFilterSearch: FormGroup;
  toggleChevron: any;
  showMoreInfoDocumentIDs: any = [];

  tokenValue = 'nahfh3209kjdlkfafslkdf-349032409324034032dskll--23432rjdslkn324234u2304320';

  @ViewChild('filterOptionModal') filterOptionModal: ElementRef;

  constructor(private dataService: DataService, public commonService: CommonService, private modalService: NgbModal, private router: Router, private encryptDecryptservice: EncryptDecryptService,
    private memorystore: MemoryStorageService
  ) { }

  ngOnInit(): void {
    //this.getStatistics();
    this.getWorkListWithCount();
    this.getWorkItems();

  }

  showHideMoreInfo(docId: number) {
    if (this.showMoreInfoDocumentIDs.includes(docId)) {
      const index = this.showMoreInfoDocumentIDs.indexOf(docId);
      this.showMoreInfoDocumentIDs.splice(index, 1);
    } else {
      this.showMoreInfoDocumentIDs.push(docId);
    }
  }

  getStatistics() {
    let params = new HttpParams;
    params = params.append("project_id", this.commonService.selectedProject);
    this.dataService.getData("dashboard-state", params).subscribe(res => {
      this.statistics = res.data[0];
    });
  }

  clearSearch() {
    if (this.searchURN == "" || this.searchURN == null || this.searchURN == undefined) {
      this.getWorkItems();
    }
    else {
      this.searchWorkItems();
    }
  }

  onIconSearchClick() {
    if (this.isDisplaySearchBox == false) {
      this.isDisplaySearchBox = true;
    }
    else {
      this.isDisplaySearchBox = false;
      this.searchURN = "";
    }
  }

  searchWorkItems() {
    if (this.searchURN == '' || this.searchURN == null || this.searchURN == undefined) {
      this.commonService.showMessageBox('Please enter the URN to search.', 'Alert');
      return;
    }
    else if (/\W/.test(this.searchURN) == true) {
      this.commonService.showMessageBox('Please enter only alphabet, number and underscore.', 'Alert');
      return;
    }

    this.getWorkItems();
  }

  async getWorkListWithCount() {

    let reqData = {};
    let searchColumns = {};

    this.advanceSearchFields.forEach((field) => {
      let val = this.frmFilterSearch.get(field.db_column_name).value;
      if (val != '') {
        if (field.control_type == 'DATE') {
          searchColumns[field.db_column_name] = this.commonService.dateFormating(val);
        }
        else {
          searchColumns[field.db_column_name] = val.toString();
        }
      }
    });

    reqData = {
      project_id: this.commonService.selectedProject,
      // user_id: this.commonService.getUserInfoFromLocalStorage('userId'),
      user_id: this.memorystore.getItem('userId'),
      document_type_id: this.selectedDocumentType.docTypeId,
      subgroup_id: this.commonService.selectedSubgroup,
      role_id: this.commonService.selectedRole,
      search_columns: searchColumns
    }
    this.lstWorkList = [];
    this.dataService.postData("work-list-count", reqData).subscribe(res => {
      if (res != null && res != undefined && res.data != null) {
        if (res.data.length > 0) {
          this.lstWorkList = res.data;
        }
      }
    });
  }

  async getWorkItems(isOpenNextItem: boolean = false) {

    this.isDisplayTransactionData = true;
    let reqData = {};
    let searchColumns = {};

    this.advanceSearchFields.forEach((field) => {
      let val = this.frmFilterSearch.get(field.db_column_name).value;
      if (val != '') {
        if (field.control_type == 'DATE') {
          searchColumns[field.db_column_name] = this.commonService.dateFormating(val);
        }
        else {
          searchColumns[field.db_column_name] = val.toString();
        }
      }
    });

    if (this.searchURN != '' && this.searchURN != null && this.searchURN != undefined) {
      searchColumns['urn'] = this.searchURN.toString();
    }

    reqData = {
      project_id: this.commonService.selectedProject,
      // user_id: this.commonService.getUserInfoFromLocalStorage('userId'),
      user_id: this.memorystore.getItem('userId'),
      worklist_id: this.selectedWorklistId,
      document_type_id: this.selectedDocumentType.docTypeId,
      role_id: this.commonService.selectedRole,
      subgroup_id: this.commonService.selectedSubgroup,
      search_columns: searchColumns
    }

    this.dataService.postData("work-items", reqData).subscribe(res => {
      if (res != null && res != undefined && res.data != null) {
        if (res.success == false) {
          this.commonService.showMessageBox('Internal Error.<br>Something went wrong.');
          return;
        }
        if (res.data.length == 0) {
          this.lstTransaction = [];
          this.isDisplayTransactionData = false;
          this.commonService.showMessageBox('No work item found for this selection.');
          return;
        } else {
          this.lstTransaction = res.data;
          this.lstTransaction.forEach(item => {
            this.showMoreInfoDocumentIDs.push(item.DOCUMENT_DETAIL_ID);
          });
          this.isDisplayTransactionData = true;
          this.totalPages = Math.ceil(this.lstTransaction.length / this.recordsPerPage);
          this.lstTotalPage = Array(this.totalPages).fill(0).map((x, i) => i);
          this.firstRecord = 1;
          this.lastRecord = (this.recordsPerPage < this.lstTransaction.length) ? this.recordsPerPage : this.lstTransaction.length;
          if (isOpenNextItem) {
            this.openTransactionModal(this.lstTransaction[0].DOCUMENT_DETAIL_ID)
          }
        }
      }
    });
  }

  openTransactionModal(documentDetailId: number) {
    let data = {
      documentDetailId: documentDetailId,
      isReadonlyMode: false
    }
    EmmiterService.get("transactionLiteModal").emit(data);
  }

  reloadDashboard(event: any) {
    if (event.reload) {
      this.getWorkListWithCount();
      this.getWorkItems(event.action == 'next');
    }
  }

  changePage(direction: string, pageNo: number) {
    if (direction == 'prev')
      this.currentPage = this.currentPage == 1 ? 1 : this.currentPage - 1;
    if (direction == 'next')
      this.currentPage = this.currentPage == this.totalPages ? this.totalPages : this.currentPage + 1;
    else if (pageNo > 0)
      this.currentPage = pageNo;

    this.firstRecord = ((this.currentPage * this.recordsPerPage) - this.recordsPerPage) + 1;
    this.lastRecord = (this.firstRecord - 1 + this.recordsPerPage < this.lstTransaction.length) ? this.firstRecord - 1 + this.recordsPerPage : this.lstTransaction.length;
  }

  changeRecordsPerPage() {
    this.totalPages = Math.ceil(this.lstTransaction.length / this.recordsPerPage);
    this.lstTotalPage = Array(this.totalPages).fill(0).map((x, i) => i);
    this.currentPage = 1;

    this.firstRecord = 1;
    this.lastRecord = (this.recordsPerPage < this.lstTransaction.length) ? this.recordsPerPage : this.lstTransaction.length;
  }

  onSelectWorkList(worklist: any) {
    if (worklist.worklist_count > 0) {
      if (this.selectedWorklistId == worklist.worklist_id) {
        this.selectedWorklistId = 0;
      } else {
        this.selectedWorklistId = worklist.worklist_id;
      }

      this.getWorkItems();
    }
  }

  showFilterModel() {

    if (this.docTypeList.length == 0) {
      this.docTypeList = [];
      let params = new HttpParams();
      // params = params.append('project_id', this.commonService.selectedProject);
      // params = params.append('subgroup_id', this.commonService.selectedSubgroup);
      params = params.append('project_id', this.encryptDecryptservice.encryptUsingAES256(this.commonService.selectedProject));
      params = params.append('subgroup_id', this.encryptDecryptservice.encryptUsingAES256(this.commonService.selectedSubgroup));
      params = params.append('xusrid', this.encryptDecryptservice.encryptUsingAES256(this.memorystore.getItem('userId')));
      this.dataService.getData('document-types', params).subscribe(res => {
        if (res != null && (res.error_message == null || res.error_message == "")) {
          if (res.data != null) {
            for (var i = 0; i < res.data.length; i++) {
              this.docTypeList.push({
                docTypeId: res.data[i].document_type_id,
                docTypeName: res.data[i].document_type_name,
              });
            }
            this.showModal(this.filterOptionModal, 'lg');
          }
        }
        else {
          if (res.errorCode != 0 && res.errorCode == 4000) {
            this.router.navigateByUrl('/unauthorized');
            return;
          }
          if (res.errorCode != 0 && res.errorCode == 3000) {
            this.commonService.showMessageBox("Internal error")
          }
        }

      },
        error => {
          this.commonService.showMessageBox(error.toString());
          if (error.includes("401")) {
            this.router.navigateByUrl('/unauthorized');
            return;
          }
        }
      );
    } else {
      this.showModal(this.filterOptionModal, 'lg');
    }
  }

  onSelectDocType(doc: any) {
    this.selectedDocumentType = doc;
    let reqData = {
      project_id: this.commonService.selectedProject,
      subgroup_id: this.commonService.selectedSubgroup,
      document_type_ids: this.selectedDocumentType.docTypeId.toString(),
    };

    this.dataService.getDataPromise('advanced-search-fields', reqData).then((res) => {
      if (res != null && res.data != null) {
        this.advanceSearchFields = res.data;
        const formControls: any = {};
        this.advanceSearchFields.forEach(async (field) => {
          field['search_value'] = '';
          if (field.control_type == 'TEXTBOX') {
            field.value_type = field.validation_type == 'NUMERIC' ? 'number' : 'text';
          }
          if (field.control_type == 'DROPDOWN') {
            field.options = await this.commonService.getDropdownData(field.field_mapping_detail_id);
            field.options.splice(0, 0, { id: 0, name: '-- Select --' });
          }
          let fieldValidators = [];
          let defaultValue: any = "";

          defaultValue = field.control_type == 'DATE' ? '' : field.control_type == 'DROPDOWN' ? '' : field.control_type == 'CHECKBOX' ? false : '';

          formControls[field.db_column_name] = new FormControl(defaultValue, fieldValidators);
        });
        this.frmFilterSearch = new FormGroup(formControls);

      }
    });
  }

  onTextChange(field: any) {
    if (field.value_type == 'number') {
      let value = this.frmFilterSearch.get(field.db_column_name).value;
      this.frmFilterSearch.get(field.db_column_name).setValue(this.setDecimalPlaces(value, field.precision_point, field.validation_type))
    }
  }

  hasValue(field) {
    let v = this.frmFilterSearch.get(field.db_column_name).value;
    if (v != undefined && v != null && v != '')
      return true
    else
      return false;
  }

  clearText(field) {
    this.frmFilterSearch.get(field.db_column_name).setValue('');
  }

  setDecimalPlaces(value: any, decimalPlace: number, validationType: string) {
    return validationType.toLowerCase() == 'numeric' ? parseFloat(value == '' ? 0 : value).toFixed(Number(decimalPlace)) : value;
  }

  openFilterFieldMagnifySearchModal(fieldMappingDetailId: number, magnifyDependantFields: string = null) {

    let dependantFieldValues = {};
    if (magnifyDependantFields != null) {
      magnifyDependantFields = JSON.parse(magnifyDependantFields);
      Object.keys(magnifyDependantFields).forEach(x => {
        let field_value = this.frmFilterSearch.get(magnifyDependantFields[x]).value;
        if (field_value != null && field_value != '' && field_value != undefined) {
          // let field = this.advanceSearchFields.find(f => f.db_column_name == magnifyDependantFields[x]);
          // if (field != undefined && field.control_type == 'DROPDOWN') {
          //   field_value = field.options.find(d => d.id == field_value).name;
          // }
          dependantFieldValues[x] = field_value.toString();
        }
      });
    }

    const modalRef = this.modalService.open(MagnifyFieldSearchComponent, {
      size: 'xl',
      centered: true,
      backdrop: 'static',
      keyboard: false,
    });
    modalRef.componentInstance.fieldMappingDetailId = fieldMappingDetailId;
    modalRef.componentInstance.dependantFieldValues = dependantFieldValues;
    modalRef.componentInstance.selectRecord.subscribe((res) => {
      const selectedField = this.advanceSearchFields.find(
        (x) => x.field_mapping_detail_id == res.fieldId
      );
      selectedField.search_value = res.fieldValue.toString();
      if (selectedField.control_type == 'DROPDOWN') {
        // if dependent field in advance search then add code here
      }
      modalRef.close();
    });
    modalRef.componentInstance.closeModal.subscribe(() => {
      modalRef.close();
    });
  }

  showModal(modelTemplate: ElementRef<any>, modalSize: string = 'lg') {
    this.modalReference = this.modalService.open(modelTemplate, {
      size: modalSize, centered: true, backdrop: 'static',
      keyboard: false
    });
  }


  getKeys(obj: any) {
    return Object.keys(obj);
  }

  getOriginalFieldName(name: string) {
    return name.replace('_BOTTOM', '');
  }
}
